import Vue from 'vue';
const EventDispatcher = new Vue();

document.onkeydown = function(evt) {
    evt = evt || window.event;
    let isEscape = false;

    if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
        isEscape = (evt.keyCode === 27);
    }

    if (isEscape) {
        EventDispatcher.$emit('key:esc');
    }
};

export {
    EventDispatcher,
}